import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { AdminCommonHttpService } from "./admin-common-http.service";

@Injectable({ providedIn: 'root' })
export class RbacAdminService {
  constructor(private commonHttp: AdminCommonHttpService) { }

  async getRolePermissions(): Promise<{ role: string; routes: string[] }[]> {
    try {
      return await this.commonHttp.getRbacRolePermissions();
    } catch (err) {
      console.error('Failed to load role permissions', err);
      return [];
    }
  }

  async setRolePermissions(role: string, permissions: string[]): Promise<boolean> {
    try {
      await this.commonHttp.setRbacRolePermissions(role, permissions);
      return true;
    } catch (err) {
      console.error('Failed to save role permissions', err);
      return false;
    }
  }

  async deleteRole(role: string): Promise<boolean> {
    try {
      await this.commonHttp.deleteRbacRole({ role })
      return true;
    } catch (err) {
      console.error('Failed to delete role', err);
      return false;
    }
  }

  async getAllRolePermissions(): Promise<{ role: string; routes: string[] }[]> {
    try {
      return await this.commonHttp.getAllRolePermissions();
    } catch (err) {
      console.error('Failed to delete role', err);
      return [];
    }
  }

}
